import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import Styles from './NoRecordsRow.module.scss';

function NoRecordsRow({ colSpan }: Readonly<{ colSpan: number }>): React.ReactElement {
    const { t } = useTranslation();
    return (
        <TableRow id={Styles.NoRecordsRow}>
            <TableCell colSpan={colSpan} sx={{ textAlign: 'center' }}>{t('NoResultsFound')}</TableCell>
        </TableRow>
    );
}

export default NoRecordsRow;
